import React from "react";
import SmallSlidePanel from "../add_customer/SmallSlidePanel";

const ContinueModal = ({
  id,
  isContinueModalOpen,
  closeContinueModal,
  closeSelfieModal,
  handleContinueButtonClick,
  customer,
}) => {
  const handleCancelButtonCLick = () => {
    closeContinueModal();
  };

  return (
    <SmallSlidePanel isOpen={isContinueModalOpen} onClose={closeContinueModal}>
      <div
        id={id}
        className="relative bg-white h-full flex flex-col rounded-[12px]"
      >
        <div className="mb-8 mx-auto items-center justify-center">
          <div className="text-[#000] text-[20px] font-normal mt-10 mx-5">
            <p>Are you sure you want to proceed?</p>
          </div>

          {customer?.id_back_image === null &&
          customer?.id_front_image === null ? (
            <div className="text-[#000] text-[15px] font-[300] mt-5 mx-5">
              <p>
                Uploading a new identity document will add it to your records.
                You can update or remove it later if needed.
              </p>
            </div>
          ) : (
            <div className="text-[#000] text-[15px] font-[300] mt-5 mx-5">
              <p>
                Replacing this document will permanently remove the original
                document. This action can not be undone!
              </p>
            </div>
          )}

          <div className="flex items-center mt-10 mx-5">
            <div className="mr-5">
              <button
                onClick={handleCancelButtonCLick}
                data-modal-toggle={id}
                type="button"
                className="text-[#FFF] bg-[#FF3232] hover:bg-[#FF3232] focus:outline-none font-[500] rounded-[5px] text-md text-medium px-5 py-2 text-center"
              >
                No, cancel
              </button>
            </div>

            <button
              onClick={handleContinueButtonClick}
              data-modal-toggle={id}
              type="button"
              className="text-[#074073] hover:bg-[#7FB8EB] focus:outline-none font-medium rounded-[5px] text-md px-5 py-2 text-center bg-[#7FB8EB]"
            >
              Yes, continue
            </button>
          </div>
        </div>
      </div>
    </SmallSlidePanel>
  );
};

export default ContinueModal;
